"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_TOTAL_CLASS_SKU_COUNT_FOR_STRATEGY_MATRIX = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_TOTAL_CLASS_SKU_COUNT_FOR_STRATEGY_MATRIX = (0, gql_1.gql)(`
  query TotalClassSkuCount($ids: [ID!], $productTreeId: ID!, $attribute: String) { 
  catalogs(ids: $ids) {
    edges { 
      node {
        id
        statistics(productTreeId: $productTreeId) {
          attributes(attribute: $attribute) { # we can call it without attribute and we get data for footer from all attributes
            groupedTotals {
              applied
              dimensions {
                productTreeNode {
                  id
                  title
                }
              }
              total
              unknown
              notApplicable
            }
          }
        }
      }
    }
  }
}
`);
